import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { Component, inject, input, OnInit } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';
import { COURSE_TAB, TabItem, UntilDestroy, untilDestroyed } from '@shared';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { combineLatest, filter, map, Observable, tap } from 'rxjs';
import {
  CategoryV2,
  CourseActionsV2,
  CourseDetailsModelV2,
  InstructorService,
  Logger,
  ProjectService,
  RouterStoreService,
  selectCategories,
  selectCourseV2,
} from 'thkee-common';
import { DrawerComponent } from '../../../@shared/components/drawer/drawer.component';
import { HistoryCourseComponent } from '../../../@shared/components/feedback/history-course/history-course.component';
import { TabMenuComponent } from '../../../@shared/components/tab-menu/tab-menu.component';
import { CourseHeaderComponent, HeaderActions } from '../components/course-header/course-header.component';
import { CourseHeadingComponent } from '../components/course-heading/course-heading.component';
const log = new Logger('CourseDetailsComponent');

@UntilDestroy()
@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  imports: [
    CourseHeaderComponent,
    CourseHeadingComponent,
    TabMenuComponent,
    NgTemplateOutlet,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
    DrawerComponent,
    AngularSvgIconModule,
    HistoryCourseComponent,
    AsyncPipe,
  ],
})
export class CoursePricingComponent implements OnInit {
  private store = inject(Store);
  private projectService = inject(ProjectService);
  private readonly instructorService = inject(InstructorService);
  private routerStore = inject(RouterStoreService);

  readonly isDefaultView = input<boolean>(true);
  courseState: string = '0';
  readOnly: boolean = true;
  modelDetails!: CourseDetailsModelV2;
  course$ = this.store.select(selectCourseV2);
  categories$!: Observable<CategoryV2[]>;
  courseId$ = this.routerStore.getParam('courseId').pipe(tap((v) => log.debug('courseId$: ', v)));

  formTier = new FormGroup({});
  formTierModel: any = {};
  formTierFields$: Observable<FormlyFieldConfig[]> = new Observable<FormlyFieldConfig[]>();
  isLoadingPrice: boolean = true;
  tabItems: TabItem[] = COURSE_TAB;

  constructor() {
    this.formTierFields$ = combineLatest([
      this.course$,
      this.instructorService.getCurrencies(),
      this.instructorService.getCoursePrice({ price_tier_status: true, page: 1, page_size: 180 }),
    ]).pipe(
      untilDestroyed(this),
      map(([course, currencies, coursePrices]) => {
        this.isLoadingPrice = false;
        const form = [
          {
            fieldGroupClassName: 'grid grid-cols-2 gap-3',
            fieldGroup: [
              {
                key: 'currency',
                type: 'select',
                // defaultValue: course.currency,
                defaultValue: course.currency_preview ?? course.currency,
                props: {
                  wrapAppendClass: ['!mb-0', 'block'],
                  required: true,
                  stylish: true,
                  disabled: true,
                  options: currencies.map((currency) => {
                    return {
                      label: currency.name,
                      value: currency.id,
                    };
                  }),
                  wrapClass: '',
                },
              },
              {
                key: 'tier',
                type: 'select',
                defaultValue: course.pricing,
                props: {
                  wrapAppendClass: ['!mb-0'],
                  required: true,
                  stylish: true,
                  disabled: true,
                  options: coursePrices.results.map((price) => {
                    return {
                      label: price.name + ' (' + price.currency_symbol + ' ' + price.price + ')',
                      value: price.id,
                    };
                  }),
                  expressionProperties: {
                    'props.options': (model: { currency: any }, formState: any, field: any) => {
                      const selectedCurrency = model.currency;
                      return coursePrices.results
                        .filter((price) => price.currency === selectedCurrency)
                        .map((price) => ({
                          label: price.name,
                          value: price.id,
                        }));
                    },
                  },
                  wrapClass: '',
                },
              },
            ],
          },
        ];
        return form;
      })
    );
  }

  ngOnInit(): void {
    this.categories$ = this.store.select(selectCategories);
    combineLatest([this.course$, this.categories$])
      .pipe(
        filter(([course, categories]) => !!course && categories.length > 0),
        untilDestroyed(this)
      )
      .subscribe(([course]) => {
        this.modelDetails = {
          ...this.modelDetails,
          ...course,
        };
      });

    // combineLatest([this.courseId$]);
    // this.formTier.valueChanges
    //   .pipe(debounceTime(AUTO_SAVE_DEBOUNCE_TIME_MS), skip(1), untilDestroyed(this))
    //   .subscribe((value) => {
    //     firstValueFrom(this.courseId$).then((courseId) => {
    //       this.instructorService
    //         .patchCourse(courseId, {
    //           pricing: this.formTierModel.tier,
    //           currency: this.formTierModel.currency,
    //         })
    //         .subscribe();
    //     });
    //     if (value) {
    //     }
    //   });
  }

  actionEvent(event: HeaderActions) {
    this.readOnly = true;
    this.courseState = '0';
    if (event === 'update') {
      this.store.dispatch(CourseActionsV2.upsertCourse({ courseDetails: this.modelDetails }));
    } else if (event === 'accept') {
      this.projectService.toStatePublished(this.modelDetails.project);
    } else if (event === 'reject') {
      this.projectService.toStateRejected(this.modelDetails.project);
    }
  }
}
